module.exports = __webpack_public_path__ + "img/approve-list18.446f461d.png";